<template>
    <div class="contenedor_contenido">
        <div class="cabecera_contenido">

        </div>
        <div class="contenido_">
            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Solicitudes de anulación
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <table class="table table-sm table-striped table-bordered" style="font-size: 12px;">
                            <thead>
                                <tr>
                                    <th style="text-align: center;width: 15%;">
                                        Sucursal
                                    </th>
                                    <th style="text-align: center;width: 20%;">
                                        Motivo
                                    </th>
                                    <th style="text-align: center;width: 10%;">
                                        NIT
                                    </th>
                                    <th style="text-align: center;width: 15%;">
                                        Nombre
                                    </th>
                                    <th style="text-align: center;width: 10%;">
                                        Serie
                                    </th>
                                    <th style="text-align: center;width: 10%;">
                                        Fecha
                                    </th>
                                    <th style="text-align: center;width: 10%;">
                                        Total
                                    </th>
                                    <th style="text-align: center;width: 10%;">
                                        ...
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, index) in listado" :key="index">
                                    <td style="text-align: center;">
                                        {{ item.nombre_sucursal }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ item.motivo }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ item.nit }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ item.nombre_cliente }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ item.serie }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ item.fecha | fecha_mod }}
                                    </td>
                                    <td style="text-align: center;">
                                        Q{{ calcular_total(item.total_movimiento, item.total_descuentos) }}
                                    </td>
                                    <td style="text-align: center;">
                                        <button type="button" style="font-size: 10px;margin-right: 5px;"
                                            class="btn btn-sm btn-outline-dark" @click="ejecutar_anulacion(item)"><i
                                                class="fas fa-check"></i></button>
                                        <button type="button" style="font-size: 10px;"
                                            class="btn btn-sm btn-outline-dark" @click="rechazar_anulacion(item)"><i
                                                class="fas fa-ban"></i></button>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-row>
            </b-container>
        </div>
        <Cargando v-if="cargando_" :titulo="'Solicitando anulación...'" />
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapActions, mapState } from 'vuex';
    import { pregunta } from '../functions/alertas';
    import Cargando from '../Loading/Cargando.vue'

    export default {
        name: 'SolicitudesDeAnulacion',
        computed: {
            ...mapState(['id_empresa_seleccionada'])
        },
        components: {
            Cargando
        },
        filters: {
            fecha_mod: function (value) {
                return moment(value).format('DD-MM-YYYY')
            }
        },
        data() {
            return {
                listado: [],
                cargando_: false
            }
        },
        methods: {
            async obtener_registros() {
                let f = {
                    api: `solicitudes-de-anulaciones/l/solicitudes-de-anulacion?empresa=${this.id_empresa_seleccionada}`
                }
                let r = await this.obtener_data(f)
                this.listado = r
            },
            calcular_total(total, descuento) {
                if (descuento == 0 || descuento == null) {
                    return total.toLocaleString(undefined, {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                    })
                } else {
                    return (total - (total - descuento)).toLocaleString(undefined, {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                    })
                }
            },
            async ejecutar_anulacion(obj) {

                pregunta({ titulo: 'Seguro que deseas aceptar la anulación la factura?', texto: 'Esta acción no se puede revertir', afirmacion: 'Si, anular!' }, async (i) => {
                    if (i) {
                        let f = {
                            api: `movimientos-cabeceras/c/anular-factura`,
                            formulario: {
                                no_autorizacion: obj.autorizacion,
                                nit_cliente: obj.nit,
                                fecha_de_emision: obj.fecha,
                                motivo: obj.motivo,
                                empresa: obj.empresa
                            }
                        }

                        this.cargando_ = true
                        let r = await this.guardar_data(f)
                        await this.obtener_registros()
                        this.cargando_ = false
                    }
                })
            },
            async rechazar_anulacion(item) {
                pregunta({ titulo: 'Seguro que deseas rechazar la anulación?', texto: 'Esta acción no se puede revertir', afirmacion: 'Si, rechazar!' }, async (i) => {
                    if (i) {
                        let f = {
                            api: `solicitudes-de-anulaciones/a/rechazar?idd=${item.document_id}`,
                            formulario: {
                                anulado: true
                            }
                        }

                        await this.actualizar_data(f)
                        await this.obtener_registros()
                    }
                })
            },
            ...mapActions(['obtener_data', 'guardar_data', 'actualizar_data'])
        },
        mounted() {
            this.obtener_registros()
        },
    }
</script>

<style></style>